// extracted by mini-css-extract-plugin
export default {"colorName":"ColorGrid_colorName__sCr99","listView":"ColorGrid_listView__9utTM","gridView":"ColorGrid_gridView__VnXNs","listSelected":"ColorGrid_listSelected__NAEZW"};